import React from 'react';
import Popper from '@mui/material/Popper';
import Fade from '@mui/material/Fade';
import ShareIcon from '@mui/icons-material/Share';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';

const sxPaper = { border: 0, p: 1, borderRadius: '6%', backgroundColor: 'background.paper' };
const sxCopiedSuccess = { ...sxPaper, color: 'green' };

export default function TransitionsPopper(prop) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [copied, setCopied] = React.useState(false);

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
    setCopied(false)
  };

  const copyClick = () =>{
    navigator.clipboard.writeText(window.location.origin+"/#/share/"+(parseInt(prop.id)-1))
    setCopied(true)
  }

  const open = Boolean(anchorEl);
  const id = open ? 'transitions-popper' : undefined;

  return (
    <div>
      <span aria-describedby={id} style={{fontSize:"1rem", color:"#1a245b"}}  onClick={handleClick}>
      <span style={{ marginBottom:"10px"}}>Share</span> <ShareIcon  style={{marginBottom: "-5px"}} />    
      </span>
      <Popper id={id} open={open} anchorEl={anchorEl} style={{marginRight:"30px"}} transition placement="left-start">
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
      <Box sx={copied ? sxCopiedSuccess : sxPaper}>{copied ? 'link copied' : 'Copy: ' + window.location.origin + '#/share/' + (parseInt(prop.id) - 1)}
        <IconButton>
          {copied ? <img alt="test" loading="lazy" onClick={() => setAnchorEl(null)} src="https://img.icons8.com/color/16/000000/checked.png" /> : <img alt="test" loading="lazy" onClick={() => copyClick()} src="https://img.icons8.com/material-outlined/24/000000/copy.png" />}
        </IconButton>
      </Box>
          </Fade>
        )}
      </Popper>
    </div>
  );
}
